module.exports = __webpack_public_path__ + "media/img/pages/companies/kmpg_ag-767e083eb420e8e6161eebd27dbb73b5.png";